import React from "react";
import {createUseStyles} from "react-jss";
import clsx from "clsx";
import {Theme} from "engage-client/theme";

const useStyles = createUseStyles<Theme>((theme) => ({
    svg: {
        fill: props => props.directionUp ? "#173F19" : "#570000",
        height: 5,
        width: 10,
		transform: props => props.directionUp ? "" : "scaleY(-1)",
        marginRight: 2,
        minWidth: 8
    },
    rankTile: {
        backgroundColor: props => props.directionUp ? theme.accessoryPanel.leaderboard.rankChange.up : theme.accessoryPanel.leaderboard.rankChange.down,
        color: props => props.directionUp ? "#173F19" : "#570000",
        height: 30,
        width: 34,
        borderRadius: 3,
        marginLeft: 2,
        display: "flex",
        padding: "auto",
		fontWeight: 700,
		fontSize: 16,
        alignItems: "center",
        justifyContent: "center",
		[theme.breakpoints.down("xs")] : {
            height: 26,
            width: 30,
			fontSize: 14,
		},
    },
}));

type RankArrowIconProps = {
    className?: string
    number: number
}

export default function RankArrowIcon(props:RankArrowIconProps){
	const classes = useStyles({
		directionUp: props.number > 0
	});
    return (
        <div className={classes.rankTile}>
            <svg className={clsx(classes.svg, props.className)} viewBox="0 0 10 5" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 5L5 0L10 5H0Z"/>
            </svg>
            {Math.abs(props.number)}
        </div>
    );
}